import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { selectPaymentSum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { IWriteOff } from '~/src/features/payments-abn/components/WriteOffDetail';
import { EPaymentTypeIds } from '~/src/features/payments-abn/store/actionCreators';
import { TState } from '~/src/store';

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

/**
 * Возвращает текст информации при списании бонусов
 */
export const selectBonusText = (state: TState): IWriteOff[] => {
    const payment = state.payment;
    const { paymentTypeId, paymentData: { bonusesValue, isUseBonuses } } = payment;

    const selectedTicket = state.seasonTicketPayment.seasonTicket;
    const { isUseBonuses: isUseBonusesSeasonTicket, amount: amountBonuses } = state.seasonTicketPayment.bonusesInfo;
    const isSeasonTicketPay = paymentTypeId === EPaymentTypeIds.WHOLESALE;

    const loyalty = state.loyalty;
    const { availability: { isRegistered } } = loyalty;

    const currentPaySum = selectPaymentSum(state);

    const baseWriteOffs: IWriteOff[] = [{
        name: 'Списать с карты',
        value: currentPaySum,
        withTooltip: true,
    }];

    const _isUseBonuses = isSeasonTicketPay ? isUseBonusesSeasonTicket : isUseBonuses;
    const _bonuses = isSeasonTicketPay
        ? amountBonuses
        : Math.round(bonusesValue * (isAbnProgramTermsEnabled ? 0.2 : 1) * 100) / 100;

    if (isRegistered && !!_bonuses && _isUseBonuses) {
        baseWriteOffs.splice(-1, 0, {
            name: 'Списать бонусами:',
            value: _bonuses,
        });
    }

    if (isSeasonTicketPay && selectedTicket) {
        const ticketInfo = {
            name: 'Абонемент:',
            value: selectedTicket.sumPrice,
        };

        baseWriteOffs.unshift(ticketInfo);
    }

    return baseWriteOffs;
};
